/**
 * Analytics page -- placeholder for future social/production analytics
 */

import { BarChart3, TrendingUp, Users, Eye } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const placeholderStats = [
  { label: "Total Views", value: "--", icon: Eye },
  { label: "Productions", value: "--", icon: BarChart3 },
  { label: "Attendees", value: "--", icon: Users },
  { label: "Engagement", value: "--", icon: TrendingUp },
];

export function Analytics() {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-vizimix-100">Analytics</h2>
        <p className="text-sm text-vizimix-400 mt-1">
          Track how your productions perform across social platforms.
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {placeholderStats.map(({ label, value, icon: Icon }) => (
          <Card key={label}>
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-vizimix-500/10">
                  <Icon className="h-5 w-5 text-vizimix-400" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-vizimix-200">{value}</p>
                  <p className="text-xs text-vizimix-500">{label}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Coming Soon */}
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-16">
          <BarChart3 className="h-12 w-12 text-vizimix-600 mb-4" />
          <h3 className="text-lg font-semibold text-vizimix-200 mb-2">
            Coming Soon
          </h3>
          <p className="text-sm text-vizimix-400 text-center max-w-md">
            Analytics will show how your productions are performing — views,
            engagement, shares, and more — across all your events.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
